import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import DocumentTabsContainer from "./DocumentTabsContainer";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledDocumentWrapper } from "../styledDocument";

const DocumentContainer = () => {
  const { t } = useTranslation("documentsPage");

  return (
    <StyledContentWrapper>
      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledDocumentWrapper>
        <DocumentTabsContainer />
      </StyledDocumentWrapper>
    </StyledContentWrapper>
  );
};

export default DocumentContainer;